export type RoboneoSiteDomain = 'roboneo.com' | 'roboneo.cn';

/**
 * 根据 hostname 解析 RoboNeo 站点主域名。
 * @param hostname 可选 hostname，默认取当前 window.location.hostname
 */
export function getRoboneoSiteDomain(hostname?: string): RoboneoSiteDomain {
  const host = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');
  return host.includes('roboneo.cn') ? 'roboneo.cn' : 'roboneo.com';
}

/**
 * 获取 navigate 使用的 originId，跟随当前访问域名。
 */
export function getNavigateOriginId(): RoboneoSiteDomain {
  return getRoboneoSiteDomain();
}
